export default "/36022bc732d21dcfe768d2a0d43278c292b1a1e5/decc719ac0c1523cc2040d71b927dcbc.svg";